export const CHAT_MESSAGE_ACTION_WINDOW_MS = 10 * 60 * 1000;

export function isWithinChatMessageActionWindow(createdAt) {
  if (!createdAt) return false;
  const createdMs = new Date(createdAt).getTime();
  if (!Number.isFinite(createdMs)) return false;
  return Date.now() - createdMs <= CHAT_MESSAGE_ACTION_WINDOW_MS;
}

export function chatActionWindowExpiredMessage() {
  return 'This action is only available within 10 minutes of sending the message.';
}

export function isMessageEdited(msg) {
  if (!msg?.updated_at || !msg?.created_at) return false;
  const updated = new Date(msg.updated_at).getTime();
  const created = new Date(msg.created_at).getTime();
  return Number.isFinite(updated) && Number.isFinite(created) && updated - created > 2000;
}
